import {Entity} from "./entity";
import {deserializeAs} from "cerialize";
import {Logo} from "./Logo";

export class Partner extends Entity {
  @deserializeAs('display_general_informations')
  displayGeneralInformations: boolean;

  @deserializeAs('general_informations_title')
  generalInformationsTitle: string;

  @deserializeAs('raison_sociale')
  raisonSociale: string;

  @deserializeAs('id')
  id: number;

  @deserializeAs(Logo, 'logo')
  logo: Logo = null;

  @deserializeAs('contact_client')
  contactClient: boolean = null;

  @deserializeAs('show_announcements')
  showAnnouncements = true;
}
